module.exports = __webpack_public_path__ + "img/invoice.07baae61.png";